export interface ProjectContactType {
    id?: number;
    project_id?: number;
    first_name?: string;
    last_name?: string;
    company_name?: string | null;
    profile_image?: string;
    mobile?: string;
    landline?: string | null;
    email?: string;
    address?: string | null;
    city?: string | null;
    post_code?: string | null;
    role_name?: string | null;
    by?: string;
}

// to single object maping
export const mapProjectContactType = (data:any): ProjectContactType => {
    if(!data){
        throw new Error('Invalid Data')
    }
    const  res: ProjectContactType ={
        id: data.id,
        project_id: data.project_id,
        first_name: data.first_name,
        last_name: data.last_name,
        company_name: data.company_name,
        profile_image: data.profile_image,
        mobile: data.mobile,
        landline: data.landline,
        email: data.email,
        address: data.address,
        city: data.city,
        post_code: data.post_code,
        role_name: data.role_name,
        by: data.by,
    }
    return res;
}

// maping list objects
export const mapProjectContactTypes = (data:any[]): ProjectContactType[] => {
     if (!Array.isArray(data)) {
       throw new Error('Invalid Data');
     }
     return data.map(mapProjectContactType);
}
